<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-a-brown-f5ebdc w-full rounded-2xl p-6 relative">
                    <div class="absolute top-3 right-3">
                        <button type="button" class="outline-none appearance-none bg-none" @click="clickClose()">
                            <img class="" src="@/assets/icon/ic-close-brown.svg" />
                        </button>
                    </div>
                    <template v-if="contentType == NotificationType.Message">
                        <NotificationTypeMessage v-bind="contentObj"></NotificationTypeMessage>
                    </template>
                    <template v-else-if="contentType == NotificationType.Badge && !isEarnReward">
                        <NotificationTypeMessage v-bind="contentObj"></NotificationTypeMessage>
                    </template>
                    <template v-else-if="contentType == NotificationType.Badge && isEarnReward">
                        <NotificationTypeBadge :campaign="campaign" @onClose="clickClose()"></NotificationTypeBadge>
                    </template>
                    <template v-else-if="contentType == NotificationType.Campaign">
                        <NotificationTypeCampaign :campaign="contentObj"></NotificationTypeCampaign>
                    </template>
                    <template v-else-if="contentType == 'BadgeCampaign'">
                        <NotificationTypeBadgeCampaign :campaign="campaign" @onClose="clickClose()"></NotificationTypeBadgeCampaign>
                    </template>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { NotificationType } from "@/helper/StaticValue";
// component
import NotificationTypeMessage from "./components/NotificationTypeMessage.vue";
import NotificationTypeCampaign from "./components/NotificationTypeCampaign.vue";
import NotificationTypeBadge from './components/NotificationTypeBadge.vue';
import NotificationTypeBadgeCampaign from './components/NotificationTypeBadgeCampaign.vue';

export default {
    name: "NotificationModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        NotificationTypeMessage,
        NotificationTypeCampaign,
        NotificationTypeBadge,
        NotificationTypeBadgeCampaign
    },
    data: function () {
        return {
            open: false,
            busModal: null,
            subscriber: null,
            contentObj: null,
            contentType: null,
            campaign: null,
            isEarnReward: false,
            NotificationType: NotificationType
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.busModal.off('show');
        this.busModal.off('hide');
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.subscriber = config.subscriber;
            this.contentType = config.type ?? null;
            this.contentObj = config.data;
            this.campaign = config.campaign;
            this.isEarnReward = config.isEarnReward

            document.body.classList.add('not-scroll');
            this.open = true;
            this.subscriber.next({
                event: "show"
            })
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
            this.subscriber.next({
                event: "hide"
            })
        },
        clickClose: function () {
            this.subscriber.next({
                event: "clickClose"
            })
            this.hide();
        },
        clickOk: function () {
            this.subscriber.next({
                event: "clickOk"
            })
            this.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content{
        width: 326px;
    }
}
</style>
